import { Carousel } from '@liveauctioneers/hammer-ui-core/carousel';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';
import { getCollectionsBaseUrl } from '@/utils/urls';

import { collectionCards } from './cards';
import { CollectionsCard } from './CollectionsCard';

type CollectionsProps = {
    className?: string;
    shouldUseHomePageRedesign?: boolean;
};

export const Collections = ({ className }: CollectionsProps) => {
    const formatMessage = useAppFormatMessage();

    const carouselCards = collectionCards.map((collection) => ({
        card: (
            <CollectionsCard
                image={collection.image}
                title={String(formatMessage(['curatedCollections', collection.titleId]))}
                to={getCollectionsBaseUrl(collection.key)}
            />
        ),
        key: collection.key,
    }));

    return (
        <div className={cn('mb-sm smMin:mb-md', className)}>
            <Carousel
                cards={carouselCards}
                title={String(formatMessage(['curatedCollections', 'header']))}
                useOverlayControls
            />
        </div>
    );
};
